/**
 * Created by pandemio on 9/20/18.
 */
import React from 'react';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

/** Multiple Language imports **/
import { renderToStaticMarkup } from 'react-dom/server'; // Fix by the author. Do not remove even if it's not resolved
import { Translate } from "react-localize-redux";
/** End of Multiple Language imports **/

/**
 * Manages the printing of PDF documents
 */
class PrintPDF extends React.Component{

    constructor(props){
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);

        this.state = {
            htmlToPrint: this.props.data
        };
        console.log(this.props);

        this.printDocument = this.printDocument.bind(this);
    }

    /**
     * Pending to receive props (of the html to print)
     * @param nextProps
     */
    componentWillReceiveProps(nextProps){
        if(nextProps.data !== undefined && nextProps.data.htmlToPrint !== undefined)
            this.setState({ htmlToPrint : nextProps.data.htmlToPrint});
        else
            this.setState({ htmlToPrint : null});
    }

    /**
     * Prints the document as PDF after being processed as an image
     */

   /* printDocument() {
        const input = document.getElementById('divToPrint');
        html2canvas(input).then((canvas) => {
                const imgData = canvas.toDataURL('image/png');
                const pdf = new jsPDF();
                pdf.addImage(imgData, 'JPEG', 20, 20);
                // pdf.output('dataurlnewwindow');
                pdf.save("download.pdf");
            });
    }*/

    /*
    printDocument(){

        const input = document.getElementById('divToPrint');
        html2canvas(input).then((canvas) => {
            const imgData = canvas.toDataURL('image/png');

        var imgWidth = 210;
        var pageHeight = 295;
        var imgHeight = canvas.height * imgWidth / canvas.width;
        var heightLeft = imgHeight;
        var doc = new jsPDF('p', 'mm');
        var position = 0;

        doc.addImage(imgData, 'PNG', 20, 20, imgWidth, imgHeight);
        heightLeft -= pageHeight;

        while (heightLeft >= 0) {
            position = heightLeft - imgHeight;
            doc.addPage();
            doc.addImage(imgData, 'PNG', 0, 20, imgWidth, imgHeight);
            heightLeft -= pageHeight;
        }
        doc.save('file.pdf')
        });
    } */

    printDocument(){

        let doc = new jsPDF();
        doc.fromHTML(
            this.state.htmlToPrint +
            '',
            15,
            15,
            {
                'width': 180
            });
            doc.save("genial-skills-user-result.pdf");
    }

    render() {
        return (
            <div>
                <button onClick={this.printDocument} className="btn btn-primary">
                    <Translate id="report-student-average.print" options={{renderInnerHtml: false}}/>
                </button>
                {/*
                <div id="divToPrint">
                { this.state.htmlToPrint != null ?
                    <div dangerouslySetInnerHTML={{ __html: (this.state.htmlToPrint)}}/> : null }
            </div> */}
        </div>);
    }
}
export default PrintPDF;


// WEBPACK FOOTER //
// ./src/components/print/print-pdf.js